module.exports = __webpack_public_path__ + "static/media/10-blushes-hue.b41822d1.jpg";